import { DocumentFilesMap } from "@dataRooms/models";
import { DocumentFile } from "@documents/models/dataGrid.models";

export const getDocumentFilesMap = (documentFiles: DocumentFile[]): DocumentFilesMap =>
  documentFiles.reduce((result, file) => {
    result[file.id] = file;

    return result;
  }, {} as DocumentFilesMap);
